import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

interface RemainingTimeResult {
  leftDays: number;
  leftHours: number;
  leftMinutes: number;
  leftSeconds: number;
  leftMilliseconds: number;
  isExpired: boolean;
}

export const useRemainingTime = ({
  endDate,
}: {
  endDate: Dayjs;
}): RemainingTimeResult => {
  // 필요시 서버에서 정확한 값을 가져와야 함
  const [serverTime, setServerTime] = useState(() => dayjs());

  const getText = (endDate: Dayjs): RemainingTimeResult => {
    const totalMilliseconds = endDate.diff(serverTime, 'millisecond');

    const isExpired = totalMilliseconds <= 0;

    if (isExpired) {
      return {
        leftDays: 0,
        leftHours: 0,
        leftMinutes: 0,
        leftSeconds: 0,
        leftMilliseconds: 0,
        isExpired,
      };
    }

    const leftDays = Math.floor(totalMilliseconds / 1000 / 60 / 60 / 24);
    const leftHours = Math.floor(totalMilliseconds / 1000 / 60 / 60) % 24;
    const leftMinutes = Math.floor(totalMilliseconds / 1000 / 60) % 60;
    const leftSeconds = Math.floor(totalMilliseconds / 1000) % 60;
    const leftMilliseconds = totalMilliseconds % 1000;

    return {
      leftDays,
      leftHours,
      leftMinutes,
      leftSeconds,
      leftMilliseconds,
      isExpired,
    };
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const localTime = Date.now();
      const serverTime = localTime;
      setServerTime(dayjs(serverTime));
    }, 10);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return getText(endDate);
};
